export default "__VITE_ASSET__f55d5c0e__"